import { RequestPromise, rawPut } from '@portal-packages/api';

import { API_CLIENTS } from '@constants/api';

import { CREATE_CONTACT } from '../constants';
import { CreateContactMutation } from '../types';

export const createContact = ({ email }: CreateContactMutation, recaptchaToken: string): RequestPromise<void> =>
  rawPut({
    client: API_CLIENTS.APP,
    entity: CREATE_CONTACT,
    url: '/actions/newsletter/contacts',
    config: {
      params: {
        email,
        recaptchaToken,
      },
    },
  });
